import "./App.css";
import "./index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import WhatsAppButton from "./components/WhatsAppButton";
import Chatbot from "./components/Chatbot";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import Personalizar from "./pages/Personalizar";
import Accesorios from "./pages/Accesorios";
import Emprende from "./pages/Emprende";
import Contacto from "./pages/Contacto";
import MisPedidos from "./pages/MisPedidos";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function Shell({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <div className="App">
      {!isAdmin && <Header />}
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <CartDrawer />}
      {!isAdmin && <WhatsAppButton />}
      {!isAdmin && <Chatbot />}
      <Toaster richColors position="top-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Shell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/personalizar" element={<Personalizar />} />
              <Route path="/accesorios" element={<Accesorios />} />
              <Route path="/emprende" element={<Emprende />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/mis-pedidos" element={<MisPedidos />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </Shell>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
